/**
 * 标签
 */

import { HTTP_ALB } from '../axios'

//  标签列表
export const getlabellist = params => {
  return HTTP_ALB.get('/system/label/list', params)
}

// 添加标签
export const addlabel = params => {
  return HTTP_ALB.post('/system/label/add', params)
}
// 编辑标签
export const editlabel = params => {
  return HTTP_ALB.post('/system/label/edit', params)
}
